import Vue from 'vue'
import App from './AppScoresNFLStatistics.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
